import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { cn } from '@/lib/utils';

/** Campaign copy supports text Markdown without embedded HTML or remote media. */
export function CampaignMarkdown({ children, className }: { children: string; className?: string }) {
  return <div className={cn('prose prose-sm prose-invert max-w-none break-words text-muted-foreground prose-headings:text-foreground prose-strong:text-foreground prose-code:text-foreground prose-a:text-primary prose-li:my-1', className)}>
    <ReactMarkdown
      skipHtml
      remarkPlugins={[remarkGfm]}
      allowedElements={['p', 'strong', 'em', 'del', 'ul', 'ol', 'li', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'blockquote', 'code', 'pre', 'a', 'hr', 'br', 'table', 'thead', 'tbody', 'tr', 'th', 'td']}
      unwrapDisallowed
      components={{
        table: ({ children }) => <div className="w-full overflow-x-auto"><table>{children}</table></div>,
        a: ({ href, children: label }) => href && /^(https?:\/\/|mailto:|\/(?!\/)|#)/i.test(href)
          ? <a href={href} {...(/^https?:\/\//i.test(href) ? { target: '_blank', rel: 'noopener noreferrer' } : {})}>{label}</a>
          : <span>{label}</span>,
      }}
    >{children}</ReactMarkdown>
  </div>;
}
